import { render } from "./Department_BugjetFinanca.vue?vue&type=template&id=571aea08&scoped=true"
import script from "./Department_BugjetFinanca.vue?vue&type=script&lang=js"
export * from "./Department_BugjetFinanca.vue?vue&type=script&lang=js"

import "./Department_BugjetFinanca.vue?vue&type=style&index=0&id=571aea08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571aea08"]])

export default __exports__